import React from 'react';
import { Badge } from './ui/Badge';

interface StatusBadgeProps {
  status: string;
}

const statusMap: Record<string, { variant: 'success' | 'error' | 'warning' | 'info' | 'muted'; label: string }> = {
  SUCCESS: { variant: 'success', label: 'Успіх' },
  FAILED: { variant: 'error', label: 'Помилка' },
  RUNNING: { variant: 'info', label: 'Виконується' },
  PENDING: { variant: 'warning', label: 'Очікує' },
  SKIPPED: { variant: 'muted', label: 'Пропущено' },
  ACTIVE: { variant: 'success', label: 'Активний' },
  INACTIVE: { variant: 'muted', label: 'Неактивний' },
  FAILED_UNIT: { variant: 'error', label: 'Помилка сервісу' },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const info = statusMap[status] ?? { variant: 'muted', label: status };
  return <Badge variant={info.variant}>{info.label}</Badge>;
}
